import qs from 'querystring';

import formatCalendarDate from './formatCalendarDate';

export default function buildGoogleCalendarUrl(calendarEvent) {
  const params = {
    action: 'TEMPLATE',
    dates: [
      formatCalendarDate(calendarEvent.startTime),
      formatCalendarDate(calendarEvent.endTime),
    ].join('/'),
    text: calendarEvent.title,
    details: calendarEvent.description,
    location: calendarEvent.location,
  };
  return `https://calendar.google.com/calendar/render?${qs.stringify(params)}`;
}
